<template>
  <el-dialog class="center-dialog" title="请选择行业类别" :visible="value" width="700" :close-on-click-modal="false" :close-on-press-escape="false" @close="cancleDialog">
    <div class="dialog-body">
      <el-scrollbar style="height: 555px;">
        <div :style="{background:index%2==0?'#f9fafb':'#fff'}" v-for="(item,index) in industryOption" :key="item.value" class="industy_box">
          <div class="left_level">
            {{ item.value }}
          </div>
          <div class="right_level">
            <div class="item_box" :style="{color:current==itemC.value?'#685ef5':''}" v-for="itemC in item.children" :key="itemC.value" @click="selectItem(itemC.value)">{{ itemC.value }}</div>
          </div>
        </div>

      </el-scrollbar>

    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="button" @click="cancleDialog">取 消</el-button>
      <el-button class="button" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { industryOption } from "../../utils/defaultData";
export default {
  name: "ChangeTypeDialog",
  data() {
    return {
      keyword: "",
      current: "", // 选中的一级分类
      checkType: null, // 选中的类型
      industryOption: industryOption,
    };
  },

  model: {
    prop: "value",
  },

  props: {
    value: {
      type: Boolean,
      require: true,
    },
    type: {
      type: String,
    },
  },

  watch: {
    value(val) {
      if (val) {
        this.current = this.type;
      }
    },
  },

  methods: {
    handleConfirm() {
      if (this.current == "") {
        this.$message.warning("请选择行业类别！");
        return;
      }
      this.$emit("confirm", this.current);
    },
    selectItem(value) {
      this.current = value;
    },
    cancleDialog() {
      this.$emit("cancle");
      this.current = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-body {
  .industy_box {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    color: #414a60;
    .left_level {
      width: 200px;
      flex-shrink: 0;
      border-right: 1px solid #d9d9d9;
      padding: 14px 18px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
    }
    .right_level {
      flex: 1;
      width: 0;
      display: grid;
      padding: 14px 18px;
      padding-bottom: 0;
      box-sizing: border-box;
      gap: 0;
      grid-template-columns: repeat(4, 1fr);
      .item_box {
        margin-bottom: 14px;
        cursor: pointer;
        &:hover {
          color: #685ef5;
        }
      }
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  .button {
    width: 90px;
    height: 34px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #685ef5;
    font-weight: 400;
    font-size: 14px;
    color: #685ef5;
    display: flex;
    align-items: center;
    justify-content: center;
    &:nth-of-type(2) {
      background: #685ef5;
      color: #fff;
    }
  }
}
</style>
